import { Injectable } from '@angular/core';
import { ICustomerSource } from '@core/interfaces/customer/customer-source.interface';
import { Observable, of } from 'rxjs';
import { ICustomer } from '@core/interfaces/customer/customer.interface';
import { Customer } from '@core/models/customer/customer.model';
import { delay } from 'rxjs/operators';
import { CUSTOMERS } from '@core/mocks/customer/customer.mock';

@Injectable()
export class CustomerSourceMockService implements ICustomerSource {

  createCustomer(customer: Customer): Observable<ICustomer> {
    return of(CUSTOMERS.results[0]).pipe(delay(300));
  }

  updateCustomer(customer: Customer): Observable<ICustomer> {
    return of(CUSTOMERS.results[0]).pipe(delay(300));
  }

}
